import React, {useContext, useState} from "react";
import {sendToEmail} from "../../../api/quotationApiClient";
import "./index.scss";
import {InputText} from "../../../components/inputs/InputText";
import {Formik} from "formik";
import {Button} from "../../../components/Button";
import config from "../../../config";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDownload} from "@fortawesome/free-solid-svg-icons";
import {OutputLink} from "../../../components/OutputLink";
import {strings} from "../../../strings/strings";
import {ProcessingContext} from "../../../contexts/ProcessingContext";
import {ProductType} from "../../../api/model/common";
import {getTypePath} from "../../../api/common";
import {FormItem} from "../../../components/inputs/FormItem";

interface SendContractToEmailFormProps {
    quotationId: string
    type: ProductType
}

export const SendContractToEmailForm = ({quotationId, type}: SendContractToEmailFormProps) => {
    const [isLoading, setLoading] = useState(true);
    const [emailFormHidden, setEmailFormHidden] = useState(true);
    const {setProcessingOpen} = useContext(ProcessingContext);


    return isLoading && <>
        <div className={"send_contract_form__actions"} hidden={!emailFormHidden}>
            <OutputLink label={strings.quotationDownload}
                        buttonStyle={true}
                        href={`${config.API_URL}/${getTypePath(type)}/printout?quotationId=${quotationId}&contractType=`}
                        icon={<FontAwesomeIcon icon={faDownload as any}/>}/>

            <Button label={strings.sendAnotherMail}
                    variant={"outlined"}
                    onClickListener={() => setEmailFormHidden(false)}/>
        </div>

        <div className={"send_contract_form__form fluid"} hidden={emailFormHidden}>
            <Formik
                onSubmit={values => {
                    setLoading(true);
                    setProcessingOpen(true);
                    sendToEmail(quotationId, values.email, type).then(response => {
                        setLoading(false);
                        setProcessingOpen(false);
                        setEmailFormHidden(true);
                    })
                }}
                initialValues={{email: ""}}
            >
                {formProps => (
                    <form onSubmit={formProps.handleSubmit}>
                        <FormItem
                            name={"email"}
                            validation={{
                                isRequired: true,
                                custom: (value) => !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{1,12}$/i.test(value) && strings.incorrectEmailErrorMessage
                            }}
                        >
                            <InputText
                                type={'text'}
                                label={strings.insuredEmail2}
                            />
                        </FormItem>

                        <Button label={strings.send} type={"submit"}/>
                    </form>
                )}
            </Formik>
        </div>
    </>
};